import { MAutocomplete, ResponsiveFormContainer } from "@app/components";
import {
  useAnalysisTypes,
  useEquipment,
} from "@services/servicesGenericsTables";
import React from "react";
import { useFormContext } from "react-hook-form";

const EquipoMideForm = () => {
  const { getValues } = useFormContext();
  const { equipmentList } = useEquipment();
  const { analysisTypeList } = useAnalysisTypes();

  return (
    <>
      <ResponsiveFormContainer columns={4}>
        <MAutocomplete
          key={JSON.stringify(getValues("equipo"))}
          name="equipo"
          options={equipmentList}
          label="Equipo"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}`
          }
          validation={{ required: `El campo equipo es requerido` }}
        />
        <MAutocomplete
          name="tipo_analisis"
          options={analysisTypeList}
          label="Análisis"
          getOptionLabel={(option) => option.descripcion}
          validation={{ required: "El analysis es requerida" }}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default EquipoMideForm;
